module.exports = __webpack_public_path__ + "static/media/menu.871fe8eb.svg";